import type { Web3Library } from '../wallet/walletContext'
import { findRecentSwapTransactionHash } from './findRecentSwapTransactionHash'
import {
  isDismissedMobileSwapHash,
  patchMobileSwapSession,
  getDismissedMobileSwapHashes,
  readMobileSwapSession,
  type MobileSwapSession,
} from './mobileSwapSession'

/** Si la sesión móvil perdió el hash tras recargar en MetaMask, lo recupera escaneando bloques recientes. */
export async function recoverMobileSwapSessionHash(
  library: Web3Library,
  account: string,
  chainId: number,
): Promise<MobileSwapSession | null> {
  const session = readMobileSwapSession()
  if (!session) return null
  if (session.hash) return session
  if (session.account.toLowerCase() !== account.toLowerCase()) return null
  if (session.chainId !== chainId) return null
  if (session.phase !== 'wallet' && session.phase !== 'submitted') return null

  const hash = await findRecentSwapTransactionHash(
    library,
    account,
    session.updatedAt,
    undefined,
    { excludeHashes: getDismissedMobileSwapHashes() },
  )
  if (!hash || isDismissedMobileSwapHash(hash)) return session

  return patchMobileSwapSession({ hash, phase: 'submitted' }) ?? session
}
